"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_SHOW: function() {
        return ADD_SHOW;
    },
    DELETE_SHOW: function() {
        return DELETE_SHOW;
    },
    DUPLICATE_SHOW: function() {
        return DUPLICATE_SHOW;
    },
    GENERATE_SHOWS: function() {
        return GENERATE_SHOWS;
    },
    RESET_SHOWS: function() {
        return RESET_SHOWS;
    },
    UPDATE_SHOW: function() {
        return UPDATE_SHOW;
    }
});
const ADD_SHOW = "ADD_SHOW";
const UPDATE_SHOW = "UPDATE_SHOW";
const DELETE_SHOW = "DELETE_SHOW";
const RESET_SHOWS = "RESET_SHOWS";
const GENERATE_SHOWS = "GENERATE_SHOWS";
const DUPLICATE_SHOW = "DUPLICATE_SHOW";
